var LeftNavigation = function() {
	this.$pageNav = $("main .navigation .ui-widget-detail > ul");
};

LeftNavigation.prototype = {
	Setup: function() {
		var $pageNavigationHeader = $("main .navigation #swada-page-navigation");
		
		if ($pageNavigationHeader.css("display") === "block") {
			var $activeListItem = this.$pageNav.find("li.active");
			$activeListItem.parents("ul,li").addClass("open");
			$activeListItem.siblings("li").addClass("visible");
			$activeListItem.parents("li.open").siblings("li").addClass("visible");

			$pageNavigationHeader.text("In this section");
			
			var classRef = this;

			$pageNavigationHeader.click( function( event ) {
				classRef._togglePageMenu( event, classRef, this )
			});
		}
	},

	_togglePageMenu : function(event, classRef, itemRef ) {
		event.preventDefault();
		event.stopPropagation();		

		if (classRef.$pageNav.css("max-height") == "0px") {
			$(itemRef).toggleClass("active");
			classRef.$pageNav.css("max-height", classRef.$pageNav[0].scrollHeight);
		}
		else {
			$(itemRef).toggleClass("active");
			classRef.$pageNav.css("max-height", "");
		}
	}
};

$( function() {
	if ($("#mobile-menu").css("display") === "block") {
		(new LeftNavigation()).Setup();
	}
});